module.exports = __webpack_public_path__ + "img/devops.26cf5a79.svg";